import { render, staticRenderFns } from "./cabinet-qualification-files.vue?vue&type=template&id=e355135a&scoped=true"
import script from "./cabinet-qualification-files.vue?vue&type=script&lang=js"
export * from "./cabinet-qualification-files.vue?vue&type=script&lang=js"
import style0 from "./cabinet-qualification-files.vue?vue&type=style&index=0&id=e355135a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e355135a",
  null
  
)

export default component.exports